// extracted by mini-css-extract-plugin
module.exports = {"item":"i_Gi","thumbnail":"i_Gj"};